export var NurseryCategory;
(function (NurseryCategory) {
    NurseryCategory[NurseryCategory["Main"] = 16] = "Main";
    NurseryCategory[NurseryCategory["Upgrade"] = 49] = "Upgrade";
})(NurseryCategory || (NurseryCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/nursery/NurseryCategory.ts
// module id = 934
// module chunks = 3